import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const BaseTooltip = ({
  id,
  text,
  placement = 'top',
  className = 'responder-tooltip',
  children,
}) => (
  <OverlayTrigger
    placement={placement}
    overlay={
      <Tooltip id={id} className={className}>
        {text}
      </Tooltip>
    }
  >
    {children}
  </OverlayTrigger>
);

export default BaseTooltip;
